/**
 * Product tile image-hover quick buy should add the base variant only.
 * Keystone injects option properties and cart UI (edit button, addon pricing)
 * even when customers never chose options on the product page.
 */
(function () {
  const TILE_QUICK_BUY_PROPERTY = 'properties[_tile_quick_buy]';

  function isTileQuickBuyFormData(formData) {
    return formData.has(TILE_QUICK_BUY_PROPERTY);
  }

  function sanitizeTileQuickBuyFormData(formData) {
    if (!isTileQuickBuyFormData(formData)) {
      return formData;
    }

    const cleanData = new FormData();

    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && key !== TILE_QUICK_BUY_PROPERTY) {
        continue;
      }

      cleanData.append(key, value);
    }

    return cleanData;
  }

  function isCartAddRequest(input) {
    const url = typeof input === 'string' ? input : input?.url;

    return Boolean(url && url.includes('/cart/add'));
  }

  const nativeFetch = window.fetch;

  window.fetch = function fetchWithTileQuickBuySanitizer(input, init) {
    if (init?.body instanceof FormData && isCartAddRequest(input)) {
      init = {
        ...init,
        body: sanitizeTileQuickBuyFormData(init.body),
      };
    }

    return nativeFetch.call(this, input, init);
  };

  function hideTileQuickBuyEditButtons(root) {
    root.querySelectorAll('[data-tile-quick-buy] .key-cart-edit-btn').forEach((button) => {
      button.hidden = true;
      button.style.display = 'none';
      button.setAttribute('aria-hidden', 'true');
    });

    root.querySelectorAll('.key-cart-edit-btn').forEach((button) => {
      if (button.closest('[data-tile-quick-buy]')) {
        button.hidden = true;
        button.style.display = 'none';
        button.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function ensureStyles() {
    if (document.getElementById('keystone-tile-quick-buy-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'keystone-tile-quick-buy-styles';
    style.textContent =
      '[data-tile-quick-buy] .key-cart-edit-btn { display: none !important; }';
    document.head.appendChild(style);
  }

  function refreshCartUi() {
    ensureStyles();
    hideTileQuickBuyEditButtons(document);
  }

  document.addEventListener('DOMContentLoaded', refreshCartUi);
  document.addEventListener('baseline:cart:afteradditem', refreshCartUi);
  document.addEventListener('baseline:cart:update', refreshCartUi);
  document.addEventListener('baseline:cart:cartqtychange', refreshCartUi);

  const observer = new MutationObserver(refreshCartUi);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  refreshCartUi();
})();
